import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";
import { useUserInfo } from "../../store/User.state";

interface IGetMerchantsWithParentMerchantRequest {
  status?: string;
  merchantId?: string;
  isPayoutBlocked?: boolean;
}

type IGetMerchantsWithParentMerchantResponse = BaseResponse<any>;

async function getMerchantsWithParentMerchant(merchantId: string | number, status?: string, isGoldBinding?: boolean | false): Promise<IGetMerchantsWithParentMerchantResponse> {
  try {
    const response = await axiosInstance.get("/Merchant/GetMerchantsWithParentMerchant", {
      params: {
        merchantId: merchantId,
        status: status,
        isGoldBinding: isGoldBinding
      }
    });
    return response.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}


export function useGetMerchantsWithParentMerchant(status?: string, isGoldBinding?: boolean | false) {
  const [userInfo] = useUserInfo();

  return useQuery<any | undefined, Error>(
    [QueryKeys.GetMerchantsWithParentMerchant, status],
    () => getMerchantsWithParentMerchant(userInfo.merchantId, status, isGoldBinding)
  );
}
